import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { LeftOutlined } from '@ant-design/icons';
import {
  Typography,
  Input,
  Table,
  Modal,
  Popconfirm,
  message,
  InputNumber,
  Select,
  Button,
} from 'antd';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import api from '../../api';
import connectCSKH from '../../utils/connectCSKH';
import './Vay.scss';
import { months } from 'moment';
// import CurrencyInput from 'react-currency-input-field';

const { Option } = Select;

export default function Vay() {
  const [verify, setVerify] = useState('confirm');
  const monthData = [6, 12,18, 24, 36, 48];
  const amounts = [10000000, 15000000, 20000000, 25000000, 30000000, 35000000, 40000000, 45000000, 50000000, 55000000, 60000000, 65000000, 70000000, 75000000, 80000000, 85000000, 90000000, 95000000, 100000000];

  const current = new Date();
  const date = `${current.getDate()}/${current.getMonth() + 1
    }/${current.getFullYear()}`;
  const history = useHistory();
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state._auth);
  const { cskh } = useSelector((state) => state._content);
  const [amount, setAmount] = useState(null);
  const [month, setMonth] = useState(null);
  const [showDetail, setShowDetail] = useState(false);
  const [notModal, setNotModal] = useState(false);
  const interestRate = Math.round(amount * 0.02 * month);
  const payback = amount + interestRate;
  const onConfirm = async () => {
    const { data } = await api.get('/contracts');
    if (data.data.length > 0) {
      setNotModal(true);
      return;
    }
    if (isNaN(amount) || amount < 10000000 || amount > 100000000) {
      message.error(`대출한도는 1,000만원에서 1억까지 입니다.`);
      return;
    }
    dispatch({
      type: 'DISPATCH_CONTRACT',
      payload: { contract: { times: month, amount } },
    });
    if (profile?.kyc?.name) history.replace('/contracts');
    else history.replace('/verify');
  };
  return (
    <div className="container">
      <div className="head" />
      <div className="vay-header" style={{ background: '#006997' }}>
        <motion.div
          whileTap={{ scale: 0.95, x: -10 }}
          onClick={() => history.replace('/')}
        >
          <LeftOutlined className="arrow-icon" style={{ color: '#fff' }} />
        </motion.div>
        <Typography.Text className="header-text" style={{ color: '#fff' }}>
          대출을 선택하세요
        </Typography.Text>
        <div />
      </div>

      <div className="vay-body">
        <div className="title-container">
          <Typography.Text className="title" style={{ color: '#fff' }}>
            대출금액
          </Typography.Text>
        </div>
        <div className="input-container">
          <Select
            onChange={(value) => setAmount(value)}
            value={amount}
            style={{ minWidth: '100%' }}
          >
            {amounts.map((value) => (
              <Select.Option key={value} value={value} className="month-picker">
                {value.toLocaleString()}
              </Select.Option>
            ))}
          </Select>
          {/* <Input
            className="input-field"
            placeholder="빌릴 금액을 입력하세요"
            style={{ minWidth: '100%' }}
            min={10000000}
            max={100000000}
            onChange={(value) => setAmount(parseInt(value.target.value.replace(/\./g, '')))}
          /> */}
          {/* <Input
            value={amount}
            className=""
            min={0}
            max={1000000000}
            placeholder="Nhập số tiền bạn cần vay"
            onChange={(e) => setAmount(parseInt(e.target.value))}
          /> */}
        </div>
        <div className="subtitle">
          <Typography.Text>10,000,000원부터</Typography.Text>
          <Typography.Text>최대 100,000,000원</Typography.Text>
        </div>
        <div className="month-container" style={{ padding: 10 }}>
          <Typography.Text>대출기간을 선택하세요</Typography.Text>
          <Select
            onChange={(value) => setMonth(value)}
            value={month}
            style={{ borderRadius: 100, minWidth: 150 }}
          >
            {monthData.map((value) => (
              <Select.Option key={value} value={value} className="month-picker">
                {value}개월
              </Select.Option>
            ))}
          </Select>
        </div>
      </div>
      <div className="form-container">
        <div className="information-form">
          <Typography.Text
            className="form-title"
            style={{ color: '#fff', fontWeight: 'bold' }}
          >
            대출정보
          </Typography.Text>
          <div className="information">
            <div className="details-information">
              <Typography.Text>금액</Typography.Text>
              <Typography.Text>{amount?.toLocaleString()}원</Typography.Text>
            </div>
            <div className="details-information">
              <Typography.Text>대출기간</Typography.Text>
              <Typography.Text>{month}개월</Typography.Text>
            </div>
            <div className="details-information">
              <Typography.Text>대출일</Typography.Text>
              <Typography.Text>{date}</Typography.Text>
            </div>
            <div className="details-information">
              <Typography.Text>결제수단</Typography.Text>
              <Typography.Text>매달 분할 납부</Typography.Text>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="old-debt-text">
          <Typography.Text style={{ flex: 2, color: '#666', fontSize: 14 }}>
            첫 번째 할부 채무 상환
          </Typography.Text>
          <Typography.Text style={{ flex: 2, color: '#3e3e3e', fontSize: 16 }}>
            {Math.round(amount / month + amount * 0.01).toLocaleString()}원
          </Typography.Text>
        </div>
        <div className="old-debt-text">
          <Typography.Text style={{ flex: 2, color: '#666', fontSize: 14 }}>
            월 이자율
          </Typography.Text>
          <Typography.Text style={{ flex: 2, color: '#3e3e3e', fontSize: 16 }}>
            0.9%
          </Typography.Text>
        </div>
        <div className="old-debt-text">
          <Typography.Link onClick={() => setShowDetail(true)}>
            상환내역
          </Typography.Link>
        </div>
      </div>
      <div className="btn-container">
        <Popconfirm
          title={`${month}개월간 ${amount?.toLocaleString() || 0}원 대출에 동의하시나요?`}
          onConfirm={onConfirm}
        >
          <Button className="confirm-btn">
            <Typography.Text className="btn-title">
              대출확인
            </Typography.Text>
          </Button>
        </Popconfirm>
      </div>

      <ModalDetailPayment
        visible={showDetail}
        onCancel={() => setShowDetail(false)}
        times={month}
        amount={amount}
      />
      <>
        <Modal
          title={null}
          footer={null}
          visible={notModal}
          closable={false}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              background: '#002dbf',
            }}
          >
            <Typography.Text style={{ color: '#fff', fontSize: 17 }} strong>
              공고
            </Typography.Text>
          </div>
          <br />
          <Typography.Text
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            당신은 대출이 미납되어 있습니다
          </Typography.Text>
          <Typography.Text
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            새로운 프로필을 등록할 수 없습니다
          </Typography.Text>
          <Typography.Text
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            조언과 지원을 받으려면 고객 서비스에 문의하십시오.
          </Typography.Text>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingTop: 30,
            }}
          >
            <motion.div
              whileTap={{ opacity: 0.4, scale: 0.97 }}
              style={{
                background: '#888',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 10,
                padding: '0px 10px',
              }}
              onClick={() => setNotModal(false)}
            >
              <Typography.Text
                style={{ fontSize: 14, color: '#fff', fontWeight: 'bold' }}
              >
                닫다
              </Typography.Text>
            </motion.div>

            <motion.div
              whileTap={{ opacity: 0.4, scale: 0.97 }}
              style={{
                background: '#002dbf',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 10,
                padding: '0px 10px',
              }}
              onClick={() => connectCSKH(profile)}
            >
              <Typography.Text
                style={{ color: '#fff', fontWeight: 400, fontSize: 14 }}
              >
                고객 지원팀에 연락하기
              </Typography.Text>
            </motion.div>
          </div>
        </Modal>
      </>
    </div>
  );
}
const ModalDetailPayment = ({ visible, onCancel, times, amount }) => {
  const array = [...new Array(times)].map((item, index) => ({
    index: index + 1,
    amount: amount / times + (amount - (index * amount) / times) * 0.01,
    period: `${new Date().getDate()} - ${(new Date().getMonth() + 1 + index + 1) % 12 === 0
      ? 12
      : (new Date().getMonth() + 1 + index + 1) % 12
      }`,
  }));
  const columns = [
    {
      title: '기',
      dataIndex: 'index',
      key: 'index',
      render: (text) => <Typography.Text>{text}기</Typography.Text>,
    },
    {
      title: '금액',
      dataIndex: 'amount',
      key: 'amount',
      render: (text) => (
        <Typography.Text strong>
          {Math.ceil(text).toLocaleString()}
        </Typography.Text>
      ),
    },
    {
      title: '마감일',
      dataIndex: 'period',
      key: 'period',
      render: (text) => <Typography.Text strong>{text}</Typography.Text>,
    },
  ];
  return (
    <Modal
      visible={visible}
      onOk={onCancel}
      cancelButtonProps={{ style: { display: 'none' } }}
      closeIcon={() => <></>}
    >
      <div style={{ maxHeight: 350, overflowY: 'scroll' }}>
        <Table dataSource={array} columns={columns} pagination={false} />
      </div>
    </Modal>
  );
};
